<template lang="pug">
    ModalBase(
      v-model="dialog"
      :max-width="isMobile ? '100%' : '80%'"
      :max-height="isMobile ? '90vh' : '70vh'"
      cancel-text="Cancelar"
      confirm-text="Concordar"
      :confirm-color="'primary'"
      :closeable="false"
      :fullscreen="true"
      :persistent="true"
      :hide-all-actions="true"
      :loading="loading"
    )
      template(#title)
        span Termos e Condições de Uso
      template(#content)
        v-row(:justify="isMobile ? 'center' : 'start'" no-gutters)
          v-col(cols=12)
            div.terms-box
              span.multiline-text(v-html="dsTermosUso + '<hr>'+ warningMessage")
              v-row(:justify="'end'")
                v-col(cols="auto")
                  ButtonComponent(
                    data-cy="btn-card-cancelar"
                    label="Cancelar"
                    color="cancelColor"
                    outlined
                    text-color="clearButtonTextColor"
                    :disabled="loading"
                    @click="logout()"
                  )
                v-col(cols="auto")
                  ButtonComponent(
                    data-cy="btn-card-concordar"
                    label="Concordar"
                    color="primary"
                    :disabled="loading"
                    @click="confirmAceite()"
                  )
</template>

<script>
import { mapFields } from "vuex-map-fields";
import ClearButton from "@/mixins/button/ClearButton.js";
import { mapGetters } from "vuex";

const snackbarOptions = {
  timeout: 10000,
  color: "lighterError",
};

export default {
  name: "ModalRegulamentos",
  components: {
    ModalBase: () => import("@/components/modal/ModalBase.vue"),
    ButtonComponent: () => import("@/components/button/ButtonComponent.vue"),
  },
  mixins: [ClearButton],
  data() {
    return {
      dialog: false,
      loading: false,
      warningMessage: "",
    };
  },
  computed: {
    ...mapGetters("regulamentos", ["getDtAtualizacao"]),
    ...mapFields("regulamentos", ["dsTermosUso"]),
  },
  methods: {
    async confirmAceite() {
      this.loading = true;
      const { status } = await this.$store.dispatch(
        "users/updateVersaoAceiteTermos"
      );

      console.log("Confirmed aceite", status);

      if (status >= 200 && status < 300) {
        await this.$store.dispatch("auth/refreshToken");
        this.$root.snackbar.show({
          ...snackbarOptions,
          color: "lighterSuccess",
          message: "Termos aceitos com sucesso!",
        });
      } else {
        this.$root.snackbar.show({
          ...snackbarOptions,
          message: "Erro ao aceitar termos! Tente novamente mais tarde.",
        });
      }

      this.dialog = false;
      this.loading = false;
    },
    async openModal() {
      const { status } = await this.$store.dispatch(
        "regulamentos/getRegulamentoAtual"
      );
      this.warningMessage = `<br><b>Se você não concordar com os termos, não poderá acessar o sistema. <br> Termos atualizados em: ${this.getDtAtualizacao}</b>`;
      if (status >= 300 || status < 200) {
        this.$root.snackbar.show({
          ...snackbarOptions,
          message:
            "Erro ao buscar termos de uso! Tente novamente mais tarde ou entre em contato com o administrador.",
        });
      }

      this.dialog = true;
    },
    logout() {
      this.$store.dispatch("auth/logout");
    },
  },
};
</script>

<style lang="sass" scoped>
.terms-box
  max-height: 86vh
  overflow-y: auto
  padding: 16px
  border: 1px solid #ccc
  border-radius: 4px

.multiline-text
  white-space: pre-line
</style>
